import { FileRecord } from "@/models/club";
import { useGetImage } from "@/utilities/helper/getImage";
import { Image } from "@mantine/core";

type Props = {
  image: FileRecord;
  h: number;
};

function ImageItem({ image, h }: Props) {
  const { imageUrl } = useGetImage({ image: image , bucket : "merchantGallery" });
  return (
    <Image
      radius="md"
      src={imageUrl || ""}
      alt={image.originalName || ""}
      fit="cover"
      loading="lazy"
      h={h}
      fallbackSrc="https://placehold.co/600x400?text=%D9%BE%D8%AF%DB%8C%DA%A9%D8%B3"
    />
  );
}

export default ImageItem;
